/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LexplusKundeStatusEnum {
  Analysis = 0,
  Update = 1,
  Inquiry = 2,
  InquirySent = 3,
  DocumentReceived = 4,
  QS = 5,
  QSClosed = 6,
  Sent = 7,
  Inactive = 8,
  Newsletter = 9
}
